(function ($) {
    function toggleMenu(e) {
        e.preventDefault();

        var fullSizeLeft = '30%';
        var halfSizeLeft = '70%';

        var left = '';

        if ($(window).width() <= 800) {
            left = halfSizeLeft;
        } else {
            left = fullSizeLeft;
        }

        var hamburger = $('#full-menu');
        var pageWrapper = $('.page-wrapper, .main-links');
        var cabinetDiv = $('.cabinet>div');

        if (hamburger.hasClass('closed') && !hamburger.hasClass('animated')) {
            hamburger.removeClass('closed').addClass('opened').addClass('animated');
            pageWrapper.animate({'left': left}, function () {
                hamburger.removeClass('animated');
            });
            cabinetDiv.animate({'left': '0'});
        } else if (hamburger.hasClass('opened') && !hamburger.hasClass('animated')) {
            hamburger.removeClass('opened').addClass('closed').addClass('animated');
            pageWrapper.animate({'left': '0'}, function () {
                hamburger.removeClass('animated');
            });
            cabinetDiv.animate({'left': '-' + left});
        }
    }

    function menuCleanup() {
        var hamburger = $('#full-menu');
        var pageWrapper = $('.page-wrapper, .main-links');
        var cabinetDiv = $('.cabinet>div');

        hamburger.removeClass('closed')
            .removeClass('.opened')
            .removeClass('animated')
            .addClass('closed');
        pageWrapper.css('left', '');
        cabinetDiv.css('left', '');
    }

    $(document).ready(function () {
        $('#full-menu').click(toggleMenu);
    });

    $(window).resize(menuCleanup);
})(jQuery);